import { styled } from "@mui/material/styles";

export const FilterMenuTitle = styled("div")(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
}));
